import useSWRImmutable from 'swr/immutable';
import TripService from '@/services/TourServices/TripService';

const useTripInclusionsExclusions = () => useSWRImmutable(
    'trip-inclusions-exclusions',
    TripService.getInclusionsExclusions,
);

export default useTripInclusionsExclusions;
